import icon from 'vue-svgicon';

icon.register({
    'regular/navigation-arrows-left-1': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M9.529 13.14a1.5 1.5 0 0 1 0-2.286L20.779 1.1a1.5 1.5 0 0 1 2.472 1.143v19.5a1.5 1.5 0 0 1-2.472 1.143z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="1" d="M15 21v.75a1.5 1.5 0 0 1-2.472 1.143L1.279 13.14a1.5 1.5 0 0 1 0-2.286L12.529 1.1A1.5 1.5 0 0 1 15 2.247V3" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
